import { QuestionCircleOutlined } from "@ant-design/icons";
import { SelectLang as UmiSelectLang } from "@umijs/max";

export type SiderTheme = "light" | "dark";

//@ts-ignore
export const SelectLang: React.FC = () => {
  return (
    <UmiSelectLang
      style={{
        padding: 4,
      }}
      postLocalesData={() => [
        {
          lang: "zh-CN",
          label: "简体中文",
          icon: "🇨🇳",
          title: "语言",
        },
        // {
        //   lang: 'en-US',
        //   label: 'English',
        //   icon: '🇺🇸',
        //   title: 'Language',
        // },
      ]}
    />
  );
};

// @ts-ignore
export const Question: React.FC = () => {
  return (
    <a
      href="https://pro.ant.design/docs/getting-started"
      target="_blank"
      rel="noreferrer"
      style={{
        display: "inline-flex",
        padding: "4px",
        fontSize: "18px",
        color: "inherit",
      }}
    >
      <QuestionCircleOutlined />
    </a>
  );
};
